import { Box } from '@material-ui/core';
import { Currency, formatMoney } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

interface CartTotalProps {
  cartTotal: number;
  currency: Currency;
}

export const CartTotal = ({ cartTotal, currency }: CartTotalProps) => {
  const { md } = useScreen();
  return (
    <Box mt={md ? 2 : 4} display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
      <Font variant={'body1'} style={{ textTransform: 'uppercase' }}>
        <strong>
          <Text tId={'TOTAL'} />
        </strong>
      </Font>
      <Box display={'flex'} flexDirection={'column'}>
        <Font variant={'h3'} color="title" style={{ textAlign: 'right', marginTop: -6, paddingBottom: 4 }}>
          {formatMoney({ value: cartTotal, currency }, 2)}
        </Font>
      </Box>
    </Box>
  );
};
